import { useState, useCallback } from 'react';

export const useLightbox = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openLightbox = useCallback((allImages: string[], index: number) => {
    setImages(allImages);
    setCurrentIndex(index);
    setIsOpen(true);
  }, []);

  const closeLightbox = useCallback(() => {
    setIsOpen(false);
  }, []);

  return { 
    isOpen, 
    images, 
    currentIndex, 
    setCurrentIndex, 
    openLightbox, 
    closeLightbox 
  };
};